module.exports = __webpack_public_path__ + "static/img/06.01e8c8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/eggenberger/06.jpg
// module id = 366
// module chunks = 1